import { useState } from "react";
import { Heart } from "react-feather";
import { Card, CardBody, Col } from "reactstrap";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DismissingDarkAlertTitle } from "../../../../Constants/Constants";
import { DismissAlertSubTitle } from "../../../../Data/UiKits/Alert";

const DismissingDarkAlert = () => {
  const [active, setActive] = useState(true);
  return (
    <Col sm="12" xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={DismissingDarkAlertTitle} span={DismissAlertSubTitle} />
        <CardBody>
          <Alerts color="secondary" isOpen={active} className={`alert-dismissible fade`}>
            <Heart />
            <P>{"Check your update! You should check in on some of those fields below."}</P>
            <Btn color="transperant" close onClick={() => setActive(false)} />
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DismissingDarkAlert;
